const CLICK_CHECK = {canClick: true};
export function setupClicker(buttonDisplayObj, clickHandler) {
    let f = () => {
        // console.log('click function');
        if (CLICK_CHECK.canClick) {
            // console.log('click accepted');
            CLICK_CHECK.canClick = false;
            setTimeout(enableClick, 20);
            clickHandler();
        }
    }
    buttonDisplayObj.interactive = true;
    buttonDisplayObj.on('pointerdown', f);
    buttonDisplayObj.on('mousedown', f);
    buttonDisplayObj.on('touchstart', f);
}

function enableClick() {
    // console.log('enabling click');
    CLICK_CHECK.canClick = true;
}